import React, { Component } from 'react';
import injectSheet from 'react-jss';
import { Subscribe } from 'unstated';

import { gql } from 'apollo-boost';
import { Query } from 'react-apollo';
import _ from 'lodash';
import faker from 'faker';
import HeaderPage from './HeaderPage';
import WrapUpContainer from '../containers/WrapUpContainer';
import Footer from '../components/Footer';
import CustomFieldsCard from '../components/CustomFieldsCard';
import ManagementParticipantsSessionCard from '../components/ManagementParticipantsSessionCard';
import RemoveUserConfirmation from '../components/RemoveUserConfirmation';
import session from '../models/Session';
import Draft from '../models/Draft';
import Template from '../models/Template';
import Story from '../models/Story';
import User from '../models/User';


const styles = {
  wrapUpCardWrapper: {
    margin: '0 auto',
    width: '37.5rem',
  },
};

const GET_DRAFT_BY_ID = id => gql`
  query {
    draftWithParents(_id: "${id}") {
      _id
      title,
      blurb,
      image,
      createdBy {
        _id 
        displayName
        image
      }
      createdAt,
      participants {
        displayName,
        image,
        _id
      },
     parents {
      image
      parentId
      parentType
      prompt
      _id
      blurb
      title
      name
      }
      sessions {
        index,
        _id
        fields
      }
      template {
        _id,
        name,
        slug,
        sessions {
          description,
          index,
          output {
            name,
            slug,
            type,
            _id
          }
        }
      }
    }
  }
`;

class WrapUpPage extends Component {
  componentDidMount() {
    if (this.props.wrapUpSession) {
      this.props.wrapUpSession.setup();
    }
  }

  componentWillUnmount() {
    this.props.wrapUpSession.destroy();
  }

  render() {
    const { classes, wrapUpSession } = this.props;

    return (
      <Query query={GET_DRAFT_BY_ID(this.props.match.params.id)}>
        {({ loading, error, data }) => {
          if (data.draftWithParents) {

            // Assume need to use all backend data if state haven't been poopulatedd
            // with drat, template, story etc
            if (!(wrapUpSession.state.story && wrapUpSession.state.template)) {
              session.set({
                template: new Template(data.draftWithParents.template),
                draft: new Draft(data.draftWithParents),
                story: new Story(data.draftWithParents)
              });

              session.get('story').set({
                createdBy: session.get('user'),
                createdAt: new Date(),
                draft: session.get('draft'),
                temp: session.get('temp')
              })

              var temp = session.get('story').temp;

              if(temp != []){
                for(var i = 0; i<temp.length; i++){
                  session.get('story').set(temp[i])
                }
              }

              wrapUpSession.setup();
            }
          }
          
          if (!(wrapUpSession.state.story && wrapUpSession.state.story.title)) {
            return null; 
          }

          const outputs = _.reduce(wrapUpSession.state.template.sessions, (acc, session) => {
            session.output.forEach(output => acc[output.name] = output);
            return acc; 
          }, {});
      

          const storyOutputs = _.pickBy(outputs, (val, key) => /title|blurb/i.test(key)); 
          const noteOutputs = _.pickBy(outputs, (val, key) => /notes/i.test(key));
          const everythingElseOutputs = _.pickBy(outputs, (val, key) => !/title|blurb|notes/i.test(key));
      
          const finalOutputs = _.concat(
            _.values(storyOutputs),
            _.values(everythingElseOutputs),
            _.values(noteOutputs)
          );

          console.log(finalOutputs)
      
          return (<div>
            <HeaderPage
              titleHeader="Wrap Up"
              descriptionHeader="Short The Jam Leader will be able to tweak/format any necessary changes."
              descriptionHeader2="Note: This is not a session and any changes will be tracked."
            />
            <div className={classes.wrapUpCardWrapper}>
              <ManagementParticipantsSessionCard wrapUp isRemovedFromLastSession={wrapUpSession.state.isRemovedFromLastSession} removeFromPreviousBtn={wrapUpSession.removeFromPreviousBtn} participants={wrapUpSession.state.draft.participants} createdBy={wrapUpSession.state.story.createdBy || User.mock()} />
              <RemoveUserConfirmation
                participant={
                  {
                    id: '1212',
                    image: faker.image.avatar(),
                    displayName: faker.name.findName(),
                  }
                }
                modal={wrapUpSession.state.modal}
                handleCancelBtn={wrapUpSession.toggleModal}
                handleActionBtn={wrapUpSession.toggleModal}
                handleToggle={wrapUpSession.toggleModal}
              />
              {  _.values(finalOutputs).map((output, index) => {
                let storyFieldKey = _.snakeCase(output.slug); 

               /* if (/story_title|story_blurb/i.test(storyFieldKey)) {
                  storyFieldKey = storyFieldKey.replace('story_', '');
                } 

                if(storyFieldKey == "blurb"){
                  storyFieldKey = "story_blurb"
                }
                if(storyFieldKey == "title"){
                  storyFieldKey == "story_title"
                } */
                
                console.log(wrapUpSession.state)
                console.log(storyFieldKey)
                console.log(wrapUpSession.state.story[storyFieldKey])
                return (
                  <CustomFieldsCard
                    type={(/notes/i.test(output.name)) ? 'quill' : 'Text'}
                    key={output._id}
                    label={output.name}
                    tooltip={output.description}
                    onChange={wrapUpSession.handleOnChange(output)}
                    value={wrapUpSession.state.story[storyFieldKey]}
                    // placeholder={'Technology is human relationship'}
                  />
                )})
              }
            </div>
            <Footer actionBtnLabel="Publish Fruit" to="/card/detail/new" />
          </div>)
      }}
      </Query>
    );
  }


}

function WrapUpPageWrapper(props) {
  const { classes } = props;

  return (
    <Subscribe to={[WrapUpContainer]}>
      { wrapUpSession => (
        <div>
          {wrapUpSession && (
          <WrapUpPage {...props} classes={classes} wrapUpSession={wrapUpSession} />
          )}
        </div>
      )}
    </Subscribe>
  );
}

export default injectSheet(styles)(WrapUpPageWrapper);



// WEBPACK FOOTER //
// ./src/pages/WrapUpPage.js